import { render, staticRenderFns } from "./DelEdit.vue?vue&type=template&id=0bc7b314&scoped=true"
import script from "./DelEdit.vue?vue&type=script&lang=js"
export * from "./DelEdit.vue?vue&type=script&lang=js"
import style0 from "./DelEdit.vue?vue&type=style&index=0&id=0bc7b314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc7b314",
  null
  
)

export default component.exports